
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class SettlementPdfDtoModel extends Model<SettlementPdfDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'owner', type: 'OwnerDtoModel', languageString: 'settlementPdfDto.property.owner', isHidden: true, isObject: true, new: () => { return new OwnerDtoModel }, properties: () => { return OwnerDtoModel.classProperties } },
		{ name: 'company', type: 'CompanyModel', languageString: 'settlementPdfDto.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'productPlans', type: 'ProductPlanModel[]', languageString: 'settlementPdfDto.property.productPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'accountingPlans', type: 'AccountingPlanDtoModel[]', languageString: 'settlementPdfDto.property.accountingPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanDtoModel }, properties: () => { return AccountingPlanDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public owner?: OwnerDtoModel;
	public company?: CompanyModel;
	public productPlans: ProductPlanModel[];
	public accountingPlans: AccountingPlanDtoModel[];
    
	constructor(){
		super();
		this.owner = undefined;
		this.company = undefined;
		this.productPlans = [];
		this.accountingPlans = [];
		
	}
	getProperties(){
		return SettlementPdfDtoModel.classProperties;
	}
}
export class OwnerDtoModel extends Model<OwnerDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'ownerDto.property.name' },
		{ name: 'vatNumber', type: 'string', languageString: 'ownerDto.property.vatNumber' },
		{ name: 'address', type: 'string', languageString: 'ownerDto.property.address' },
		{ name: 'zipcode', type: 'string', languageString: 'ownerDto.property.zipcode' },
		{ name: 'city', type: 'string', languageString: 'ownerDto.property.city' },
		{ name: 'bankName', type: 'string', languageString: 'ownerDto.property.bankName' },
		{ name: 'bankReg', type: 'string', languageString: 'ownerDto.property.bankReg' },
		{ name: 'bankAccount', type: 'string', languageString: 'ownerDto.property.bankAccount' }
	];
	[key: string]: any;
	
	public name: string;
	public vatNumber: string;
	public address: string;
	public zipcode: string;
	public city: string;
	public bankName: string;
	public bankReg: string;
	public bankAccount: string;
    
	constructor(){
		super();
		this.name = '';
		this.vatNumber = '';
		this.address = '';
		this.zipcode = '';
		this.city = '';
		this.bankName = '';
		this.bankReg = '';
		this.bankAccount = '';
		
	}
	getProperties(){
		return OwnerDtoModel.classProperties;
	}
}
export class AccountingPlanDtoModel extends Model<AccountingPlanDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'accountingPlanId', type: 'guid', languageString: 'accountingPlanDto.property.accountingPlanId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'accountingPlanDto.property.productPlanId' },
		{ name: 'startDate', type: 'Date', languageString: 'accountingPlanDto.property.startDate' },
		{ name: 'endDate', type: 'Date', languageString: 'accountingPlanDto.property.endDate' },
		{ name: 'totalPlanValue', type: 'number', languageString: 'accountingPlanDto.property.totalPlanValue' },
		{ name: 'invoicedValue', type: 'number', languageString: 'accountingPlanDto.property.invoicedValue' }
	];
	[key: string]: any;
	
	public accountingPlanId?: string;
	public productPlanId?: string;
	public startDate?: Date;
	public endDate?: Date;
	public totalPlanValue: number;
	public invoicedValue: number;
    
	constructor(){
		super();
		this.accountingPlanId = undefined;
		this.productPlanId = undefined;
		this.startDate = undefined;
		this.endDate = undefined;
		this.totalPlanValue = 0;
		this.invoicedValue = 0;
		
	}
	getProperties(){
		return AccountingPlanDtoModel.classProperties;
	}
}

